module.exports = __webpack_public_path__ + "956abed46bf9d1e20ad5f2dfd36b9e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/navbar/order_redisign-active.png
// module id = 473
// module chunks = 0